export const GET_AGENT_COINS_API_REQUEST = 'GET_AGENT_COINS_API_REQUEST';
export const GET_AGENT_COINS_API_SUCCESS = 'GET_AGENT_COINS_API_SUCCESS';
export const GET_AGENT_COINS_API_ERROR = 'GET_AGENT_COINS_API_ERROR';